import { ToastController } from 'ionic-angular';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { _throw } from 'rxjs/observable/throw';
import { catchError } from 'rxjs/operators';
import { UserProvider } from '../../providers/user/user';
import { NavProvider } from '../../providers/nav/nav';
declare var instituicaoConstants;

@Injectable()
export class InterceptorProvider implements HttpInterceptor {
  constructor(
    private storage: Storage,
    public userProvider: UserProvider,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    private navProvider: NavProvider,
  ) { }

  // Intercepts all HTTP requests!
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let promise = this.storage.get('token');

    return Observable.fromPromise(promise).mergeMap((token) => {
      let clonedReq;
      if (request.url.indexOf('maps.googleapis.com') == -1) {
        clonedReq = this.addToken(request, token);
      } else {
        clonedReq = request;
      }

      return next.handle(clonedReq).pipe(
        catchError((error) => {
          // Perhaps display an error for specific status codes here already?
          if (token) {
            const toast = this.toastCtrl.create({
              message: this.translate.instant('Conexão perdida, tente mais tarde.'),
              duration: 3000,
            });

            toast.present();
          }

          if (error.status === 0) {
            this.userProvider.logout().then();
            this.navProvider.navegarParaLogin();

            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }

          // Pass the error to the caller of the function
          return _throw(error);
        }),
      );
    });
  }

  // Adds the token to your headers if it exists
  private addToken(request: HttpRequest<any>, token: any) {
    if (token) {
      let clone: HttpRequest<any>;
      clone = request.clone({
        setHeaders: {
          Accept: `application/json`,
          'Content-Type': `application/json`,
          Authorization: `Bearer ${token}`,
        },
      });
      return clone;
    }

    return request;
  }
}



// WEBPACK FOOTER //
// ./src/providers/interceptor/interceptor.ts